import mirror from 'keymirror';
import Pricing from '../lib/pricing';

export const actionTypes = mirror({
  PRICING_GET_ERROR: null,
  PRICING_GET_IN_PROGRESS: null,
  PRICING_GET_SUCCESS: null,
});

const pricingGetError = error => ({
  error,
  type: actionTypes.PRICING_GET_ERROR,
});

const pricingGetInProgress = () => ({
  type: actionTypes.PRICING_GET_IN_PROGRESS,
});

const pricingGetSuccess = results => ({
  results,
  type: actionTypes.PRICING_GET_SUCCESS,
});

export const getProductRates = (country, subscriptionType) => async dispatch => {
  dispatch(pricingGetInProgress());
  try {
    const pricing = await Pricing.getProductRates(country, subscriptionType);
    dispatch(pricingGetSuccess(pricing));
  } catch (err) {
    dispatch(pricingGetError(err));
  }
};
